import React, { useState } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import FormDialog from '../../../components/ui/FormDialog';
import { notify, getErrorMessage } from '../../../components/feedback/notify';
import { LimitValue } from '../../../utils/LimitValue';

export default function AdicionarDesconto(props) {
    const token = localStorage.getItem('token');

    const [discountCode, setDiscountCode] = useState('');
    const [valorDesconto, setValorDesconto] = useState('');
    const [duracaoMeses, setDuracaoMeses] = useState('');
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setDuracaoMeses('');
        setValorDesconto('');
        setDiscountCode('');
        props.setAdicionarDesconto(false);
    };

    const handleSubmit = async () => {
        if (discountCode === '' || valorDesconto === '' || duracaoMeses === '') {
            notify.warning('Por favor, preencha todos os campos.');
            return;
        }
        try {
            setLoading(true);
            await axios.post(`${process.env.REACT_APP_API_URL}/adicionarDesconto`, {
                discountCode,
                valorDesconto,
                duracaoMeses
            }, {
                headers: {
                    Authorization: token
                }
            });
            notify.success('Desconto adicionado com sucesso.');
            handleClose();
        } catch (error) {
            console.error("Erro ao adicionar desconto:", error);
            notify.error(getErrorMessage(error, 'Não foi possível adicionar o desconto.'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <FormDialog
            open={props.adicionarDesconto}
            onClose={handleClose}
            onSubmit={handleSubmit}
            title="Adicionar desconto"
            description="Crie um código promocional aplicável às assinaturas."
            submitLabel="Adicionar"
            loading={loading}
        >
            <TextField
                autoFocus
                required
                label="Código do desconto"
                placeholder="Ex.: BEMVINDO10"
                fullWidth
                value={discountCode}
                onChange={(e) => setDiscountCode(e.target.value)}
                size="small"
            />
            <TextField
                required
                label="Valor do desconto"
                placeholder="0 a 100"
                fullWidth
                value={valorDesconto}
                onChange={(e) => setValorDesconto(LimitValue(e.target.value))}
                size="small"
                slotProps={{ input: { endAdornment: <InputAdornment position="end">%</InputAdornment> } }}
            />
            <TextField
                required
                label="Duração do desconto"
                placeholder="Quantidade de meses"
                fullWidth
                value={duracaoMeses}
                onChange={(e) => setDuracaoMeses(LimitValue(e.target.value))}
                size="small"
                slotProps={{ input: { endAdornment: <InputAdornment position="end">meses</InputAdornment> } }}
            />
        </FormDialog>
    );
}
